import { Link } from 'react-router-dom';
import Div from '../../common/components/div';
import { trackLinkClick } from '../../common/analytics';
import translate from '../../common/functions/translate';

export default function CreateAccountLinkSection() {
    return <>
        <Div isRow>
            <Div cols={12}>
                {`${translate('no_account_get_more_personalized_experience')} — `}
                <Link
                    to="/create-account"
                    onClick={trackLinkClick(translate('login'))}
                >
                    {translate('create_an_account_now')}
                </Link>
            </Div>
        </Div>
    </>
}